<script setup lang="ts">
  import PosUiButton from '@/components/pos-v2/ui/PosUiButton.vue';
  import PosUiStepper from '@/components/pos-v2/ui/PosUiStepper.vue';
  withDefaults(defineProps<{ value: number; disabled?: boolean }>(), {
    disabled: false,
  });
  const emit = defineEmits<{
    (event: 'input', value: number): void;
    (event: 'choose', value: number): void;
  }>();
  function choose(value: number) {
    emit('input', value);
    emit('choose', value);
  }
</script>
<template>
  <div class="reservation-party-row">
    <div class="quick-parties">
      <PosUiButton
        v-for="party in 8"
        :key="party"
        color="neutral"
        variant="outline"
        size="xl"
        :class="{ selected: party === value }"
        :aria-pressed="party === value"
        :disabled="disabled"
        @click="choose(party)"
        >{{ party }}</PosUiButton
      >
    </div>
    <PosUiStepper
      :value="value"
      :min="1"
      :max="50"
      :disabled="disabled"
      editable
      :aria-label="$t('reservations.form.party')"
      @input="choose"
    />
  </div>
</template>
<style scoped lang="scss">
  .reservation-party-row {
    @apply tw-flex tw-flex-wrap tw-items-center tw-gap-3;
    .quick-parties {
      @apply tw-grid tw-flex-1 tw-gap-2;
      grid-template-columns: repeat(4, minmax(44px, 1fr));
      @media (min-width: 640px) {
        grid-template-columns: repeat(8, minmax(44px, 1fr));
      }
    }
    .quick-parties :deep(.pos-ui-button) {
      @apply tw-px-2 tw-tabular-nums;
      &.selected {
        @apply tw-border-neutral-900 tw-bg-neutral-900 tw-text-white;
      }
    }
  }
</style>
